export default __webpack_public_path__ + "static/media/Shadow's Belt of the Final Way.0f065779.jpg";